export function formatBlogDate(iso, language = "en") {
  if (!iso) return "";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString(language?.startsWith("fr") ? "fr-FR" : "en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}

/** Sets <meta name|property=...> content, creating the tag if needed. Returns a restore fn. */
export function setMetaTag(attr, key, content) {
  let tag = document.head.querySelector(`meta[${attr}="${key}"]`);
  const created = !tag;
  const previous = tag?.getAttribute("content");
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content || "");
  return () => {
    if (created) tag.remove();
    else tag.setAttribute("content", previous || "");
  };
}
